import React, { useContext } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';
import { createURL } from '@sm/utils';
import HeaderContext from '../../HeaderContext';

export const COPY = defineMessages({
  UPGRADE: {
    id: 'ButtonUpgrade.upgradeButton',
    defaultMessage: 'Upgrade',
    description:
      '[Type: Label][Vis.: high] - This is the upgrade addon button on the header.',
  },
});

const ButtonUpgrade = () => {
  const { pageURL, pageURLPath } = useContext(HeaderContext);
  return (
    <Button
      size="sm"
      color="upgrade"
      data-sm-metrics={generateMetricsAttribute({
        data: {
          url: pageURL,
          pageName: pageURLPath,
          amplitudeEvent: 'header clicked cta',
          ctaName: 'upgrade',
        },
      })}
      href={createURL('/pricing/upgrade/', {
        ut_source: 'header_upgrade',
        ut_source3: 'webplat',
      })}
    >
      <T desc={COPY.UPGRADE} />
    </Button>
  );
};

export default ButtonUpgrade;
